<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <strong>Informações relacionadas aos antecedentes do paciente</strong><br><div v-html="formatDescricao(item.antecedente.descricao)"></div>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxPreNatalPartoNascimento
                    v-if="item.isAtendimentoPuericultura && !item.puericultura.isPrimeiroAtendimento"
                    :item="item"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxInformacaoObstetrica
                    v-if="item.sexoId === enums.sexo.FEMININO"
                    :item="item"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxProblemaCondicao
                    :item="item"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <BoxCirurgiaInternacao
                    :item="item"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Components.
import BoxCirurgiaInternacao from './components/cirurgia-internacao/Index'
import BoxInformacaoObstetrica from './components/informacao-obstetrica/Index'
import BoxPreNatalPartoNascimento from '@/components/ambulatorio/atendimento/components/historico/components/pre-natal-parto-nascimento/Index'
import BoxProblemaCondicao from './components/problema-condicao/Index'

// Enums.
import sexo from '@/enums/cadastro/cidadao/sexo'

export default {
    components: {
        BoxCirurgiaInternacao,
        BoxInformacaoObstetrica,
        BoxPreNatalPartoNascimento,
        BoxProblemaCondicao,
    },
    data: () => ({
        enums: {sexo},
    }),
    props: {
        item: {type: Object, required: true},
    },
    methods: {
        formatDescricao(descricao) {

            if (descricao) {
                return descricao.replace(/\n/g, '<br>');
            }

            return null
        },
    }
}
</script>